module.exports = __webpack_public_path__ + "f94db17f57c2f38666f81941fd2fa523.pdf";